import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../packages/JsonQuery';

export const trackBannerShown = (sc: TJsonQuery) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Show_sopr',
    label: 'BrokerDealBanner',
    sc,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
    },
  });
};
